/**
 * CadRibbonShell — the 2D shell's ribbon block (Faz 3.2): QuickAccessBar
 * on top, the Ribbon underneath. The collapse setting is session state
 * here (the OCS app-config persistence maps to yap's settings phase).
 * Mounted by Layout.tsx for the 2D workbench when ribbonVisible is on;
 * the classic Toolbar stays the fallback for ribbonVisible = false.
 */

import { useState } from 'react';
import { QuickAccessBar } from './QuickAccessBar';
import { Ribbon, type RibbonCollapseSetting } from './Ribbon';

export function CadRibbonShell() {
    const [collapse, setCollapse] = useState<RibbonCollapseSetting>('auto');
    return (
        <>
            <QuickAccessBar />
            <Ribbon setting={collapse} onSettingChange={setCollapse} />
        </>
    );
}
